import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <div className="container">
          <h1>Terms and Conditions</h1>
          <p>Last updated: April 28, 2026</p>
        </div>
      </div>

      <div className="container policy-content my-5">
        <p className="intro">
          These Terms and Conditions govern your use of the Thrive Insurance Brokers Limited website and insurance brokerage services. By accessing, browsing, or using our website and services, you agree to be bound by these terms. If you do not agree with these terms, please refrain from using our services.
        </p>

        <section>
          <h2>Scope of Services</h2>
          <p>
            Thrive Insurance Brokers Limited provides insurance brokerage services, including insurance quotes, policy placement, claims assistance, risk advisory, and ongoing policy management. These terms apply to all interactions with our insurance brokerage services and the Thrive Insurance Brokers Limited website.
          </p>
        </section>

        <section>
          <h2>Acceptance of Terms</h2>
          <p>
            By using our website, requesting insurance quotes, or submitting personal information, you confirm that:
          </p>
          <ul>
            <li>You are at least 18 years old and have the legal capacity to enter into binding agreements.</li>
            <li>You have read, understood, and agree to be bound by these Terms and Conditions, our Privacy Policy, and all applicable regulations.</li>
            <li>All information you provide is accurate, complete, and truthful.</li>
          </ul>
        </section>

        <section>
          <h2>Insurance Brokerage Services</h2>
          <p>
            <strong>Contact Inquiries and Information Requests:</strong> When you submit inquiries through our contact form or contact us directly, we collect your name, email, phone, and message. These inquiries are processed by our team to respond to your questions about insurance services. By submitting contact information, you consent to our communication regarding your inquiry.
          </p>
          <p>
            <strong>Claim Submissions:</strong> When you report a claim through our claim reporting form, you provide insured name, policy number, email, phone, and supporting documents. This information is used to process your claim and communicate with you about the claim status. Supporting documents may include evidence of loss, accident reports, receipts, or other relevant documentation.
          </p>
          <p>
            <strong>Accuracy of Information:</strong> You acknowledge that insurance claims and insurance-related information are processed based on the accuracy and completeness of information you provide. You are responsible for ensuring that all details provided in claim reports, contact forms, and correspondence are accurate. Misrepresentation, material omission, or fraudulent information may result in claim denial or policy cancellation.
          </p>
          <p>
            <strong>Policy Terms and Underwriting:</strong> Actual insurance policies and coverage are determined by independent insurance underwriters. Thrive Insurance Brokers Limited acts as an intermediary broker. Final policy approval is subject to underwriting assessment by the insurance underwriter. Underwriters reserve the right to decline coverage or modify terms based on their underwriting guidelines.
          </p>
          <p>
            <strong>Claims Processing:</strong> Claims must be reported to Thrive Insurance Brokers Limited as soon as possible after the incident occurs. Thrive acts as a claims liaison and assists in the claims process, but final claims decisions are made by the insurance underwriter or insurance company. Claims are subject to policy terms, conditions, and exclusions. Processing times may vary depending on the complexity of the claim and documentation provided.
          </p>
          <p>
            <strong>Regulatory Compliance:</strong> Our insurance brokerage services are conducted in compliance with applicable insurance regulations including those set by NAICOM and NCRIB, and data protection requirements under NDPR in Nigeria and other jurisdictions where we operate.
          </p>
        </section>
{/* User Account Creation */}
        {/* <section>
          <h2>User Accounts and Security</h2>
          <p>
            If you create an account on our website:
          </p>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your username, password, and account information.</li>
            <li>You agree to accept responsibility for all activities and transactions conducted under your account.</li>
            <li>You must notify us immediately of any unauthorized access or security breach.</li>
            <li>You agree not to share your account credentials with third parties.</li>
          </ul>
        </section> */}

        <section>
          <h2>Use of Website</h2>
          <p>
            You agree to use our website only for lawful purposes and in accordance with these terms. You must not:
          </p>
          <ul>
            <li>Use the website to transmit any illegal, harmful, or abusive content.</li>
            <li>Damage, disable, overburden, or impair our servers, networks, or systems.</li>
            <li>Attempt to gain unauthorized access to our systems or databases.</li>
            <li>Engage in fraud, misrepresentation, or any deceptive practice.</li>
            <li>Scrape, automate access, or harvest data from our website without permission.</li>
            <li>Violate any applicable laws, regulations, or third-party rights.</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            All content on our website, including text, graphics, logos, images, charts, software, and other materials, is owned by Thrive Insurance Brokers Limited or our licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, transmit, or modify any content without our prior written consent.
          </p>
        </section>

        <section>
          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites operated by insurance underwriters, regulatory bodies, and other external sites. We are not responsible for the content, accuracy, products, services, or practices of these external sites. Your use of third-party websites is at your own risk and subject to their terms and conditions. We recommend reviewing the terms of third-party sites before engaging with them.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by applicable law:
          </p>
          <ul>
            <li>Thrive Insurance Brokers Limited shall not be liable for indirect, incidental, special, consequential, or punitive damages arising from your use of our website or services.</li>
            <li>Our total liability for any claim related to our services shall not exceed the amount you paid to us for the service in question.</li>
            <li>We are not responsible for errors or omissions in information provided by third parties (insurance underwriters, regulators, etc.), or for their failure to perform services.</li>
            <li>While we strive to provide accurate information, we do not warrant that all information on our website is error-free or current.</li>
          </ul>
          <p>
            <strong>Insurance Disclaimer:</strong> Insurance provided through Thrive Insurance Brokers Limited is issued by independent insurance underwriters. Thrive is not the insurer and does not underwrite or guarantee coverage. Coverage is subject to policy terms, conditions, exclusions, and the underwriter's acceptance.
          </p>
        </section>

        <section>
          <h2>Data Accuracy and Importance</h2>
          <p>
            Accurate information is critical to insurance claims and insurance services. You acknowledge that:
          </p>
          <ul>
            <li>Information provided in contact forms, claim reports, and insurance submissions must be complete, accurate, and truthful.</li>
            <li>Supporting documents and evidence submitted with claims must be genuine and relate to the claimed incident.</li>
            <li>All material facts and circumstances relevant to your claim must be disclosed.</li>
            <li>Failure to disclose material information or provide fraudulent documentation may result in claim rejection, policy cancellation, or referral to appropriate authorities.</li>
            <li>Changes in circumstances that affect your insurance coverage or claims must be reported promptly.</li>
            <li>Fraudulent or intentionally misleading information is a serious offense and may result in criminal proceedings, civil litigation, and referral to law enforcement.</li>
          </ul>
        </section>

        <section>
          <h2>Dispute Resolution</h2>
          <p>
            Any disputes arising from these terms or your use of our services shall be governed by the laws of Nigeria. You agree to attempt resolution through our customer service channels before pursuing legal action. In the event of unresolved disputes, either party may seek resolution through applicable arbitration or court proceedings as permitted by law.
          </p>
        </section>

        <section>
          <h2>Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Thrive Insurance Brokers Limited and its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of our website or services, violation of these terms, or infringement of any third-party rights.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these Terms and Conditions periodically to reflect changes in our services, legal requirements, or operational practices. Material changes will be posted on this page with an updated "Last updated" date. Your continued use of our services following notification of changes constitutes your acceptance of the revised terms. We recommend reviewing these terms regularly.
          </p>
        </section>

        <section>
          <h2>Regulatory Information</h2>
          <p>
            <strong>Insurance Licensing:</strong> Thrive Insurance Brokers Limited is licensed to operate as an insurance broker in Nigeria and is subject to regulation by the National Insurance Commission (NAICOM).
          </p>
          <p>
            <strong>Compliance:</strong> Our services comply with applicable insurance regulations (NAICOM, NCRIB), data protection laws including the Nigeria Data Protection Regulation (NDPR), consumer protection laws, and other relevant regulations in Nigeria and jurisdictions where we operate. Thrive Insurance Brokers Limited maintains NDPR certification, demonstrating our commitment to protecting personal data and privacy rights of all our clients in accordance with Nigerian data protection standards.
          </p>
          <p>
            <strong>Complaints:</strong> If you have complaints about our services, please contact us. You may also report complaints to the National Insurance Commission or relevant regulatory authorities.
          </p>
        </section>

        <section>
          <h2>Severability</h2>
          <p>
            If any provision of these terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect to the maximum extent permitted by law.
          </p>
        </section>

        <section>
          <h2>Entire Agreement</h2>
          <p>
            These Terms and Conditions, together with our Privacy Policy and Cookie Policy, constitute the entire agreement between you and Thrive Insurance Brokers Limited regarding your use of our website and services.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about these Terms and Conditions or complaints regarding our insurance services, please contact us through our <a href="/contact">Contact Us</a> page.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;